import React, { PropTypes, Children, PureComponent } from 'react';
import DocumentTitle from 'react-document-title';
import _ from 'underscore';

export class RootTitle extends PureComponent {
  static propTypes = {
    baseTitle: PropTypes.string.isRequired
  };

  static childContextTypes = {
    baseTitle: PropTypes.string.isRequired
  };

  getChildContext() {
    return { baseTitle: this.props.baseTitle };
  }

  render() {
    const { baseTitle, children } = this.props;

    return (
      <DocumentTitle title={baseTitle}>
        { Children.only(children) }
      </DocumentTitle>
    );
  }
}

export default class PageTitle extends PureComponent {
  static propTypes = {
    title: PropTypes.string
  };

  static contextTypes = {
    baseTitle: PropTypes.string.isRequired
  };

  render() {
    const { title, ...rest } = this.props;
    const { baseTitle } = this.context;

    return (
      <DocumentTitle title={_.compact([ title, baseTitle ]).join(' | ')} {...rest}/>
    );
  };
}


// WEBPACK FOOTER //
// ./src/js/PageTitle.jsx